export default new class IconRenderer {

  /**
   *
   * @param value
   */
  setTranslator (value) {
    this._translator = value

    return this
  }

  constructor () {
    this._translator = null
  }

  /**
   *
   * @param icons
   * @param rowData
   * @return {string}
   */
  render (icons, rowData) {
    let iconsString = ''

    iconsString = iconsString + '<div class="icons-wrapper">'
    icons.forEach((icon) => {
      let data = JSON.parse(rowData[icon.ColumnName])
      if (data.hasOwnProperty('IconClass')) {
        iconsString = iconsString + this._renderIcon(data, icon)
        return
      }

      iconsString = iconsString + this._renderLabel(data, icon)
    })

    iconsString = iconsString + '</div>'

    return iconsString
  }

  /**
   *
   * @param data
   * @param icon
   * @return {string}
   * @private
   */
  _renderLabel (data, icon) {
    return '<span class="icons-label '
      + data.ValueClass
      + '" title="'
      + this._translator.text(icon.DictionaryKeyCode) + '">'
      + data.Value
      + '</span>'
  }

  /**
   *
   * @param data
   * @param icon
   * @return {string}
   * @private
   */
  _renderIcon (data, icon) {
    let string = '<span class="badge-icon-wrapper"><i class="'
      + data.IconClass
      + '" aria-hidden="true"></i>'

    if (data.ValueClass && data.Value) {
      string = string
        + '<span class="'
        + data.ValueClass
        + '" title="'
        + this._translator.text(icon.DictionaryKeyCode) + '">'
        + data.Value
        + '</span>'
    }

    string = string + '</span>'

    return string
  }

}